import { object, InferType } from 'yup'

export const tenantSettingsSchema = object({})

export type TenantSettings = InferType<typeof tenantSettingsSchema>
